import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { makeStyles } from '@material-ui/styles';
import { Avatar, Box, ButtonBase, Tooltip } from '@material-ui/core';

// project imports
import LogoSection from '../LogoSection';
import GlobalSearch from './GlobalSearch';
import ProfileSection from './ProfileSection';
import NotificationSection from './NotificationSection';
import * as actionTypes from '../../../store/actions';

// assets
import { IconMenu2, IconSun, IconMoon } from '@tabler/icons';

// style constant
const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1
    },
    headerAvatar: {
        ...theme.typography.commonAvatar,
        ...theme.typography.mediumAvatar,
        transition: 'all .2s ease-in-out',
        background: theme.palette.secondary.light,
        color: theme.palette.secondary.dark,
        '&:hover': {
            background: theme.palette.secondary.dark,
            color: theme.palette.secondary.light
        }
    },
    boxContainer: {
        width: '228px',
        display: 'flex',
        [theme.breakpoints.down('md')]: {
            width: 'auto'
        }
    }
}));

//-----------------------|| MAIN NAVBAR / HEADER ||-----------------------//

const Header = ({ handleLeftDrawerToggle }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const navType = useSelector((state) => state.customization.navType);
    const isDark = navType === 'dark';

    const toggleDarkMode = () => {
        dispatch({ type: actionTypes.SET_NAV_TYPE, navType: isDark ? 'light' : 'dark' });
    };

    return (
        <React.Fragment>
            {/* logo & toggler button */}
            <div className={classes.boxContainer}>
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>
                <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                    <Avatar variant="rounded" className={classes.headerAvatar} onClick={handleLeftDrawerToggle} color="inherit">
                        <IconMenu2 stroke={1.5} size="1.3rem" />
                    </Avatar>
                </ButtonBase>
            </div>

            {/* header search */}
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                <GlobalSearch />
            </Box>
            <div className={classes.grow} />
            <div className={classes.grow} />

            {/* dark mode toggle */}
            <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
                <Box sx={{ mr: 1 }}>
                    <ButtonBase sx={{ borderRadius: '12px' }}>
                        <Avatar variant="rounded" className={classes.headerAvatar} onClick={toggleDarkMode} color="inherit">
                            {isDark ? <IconSun stroke={1.5} size="1.3rem" /> : <IconMoon stroke={1.5} size="1.3rem" />}
                        </Avatar>
                    </ButtonBase>
                </Box>
            </Tooltip>

            {/* notification & profile */}
            {/* <NotificationSection /> */}
            <ProfileSection />
        </React.Fragment>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
